<template>
  <div id="app">
    <div class="vue-json-form">
      <h1>Mulesoft Cores</h1>
      <MulesoftTable @coreName="setCoreConfig" />

      <br />
      <br />
      <div v-if="coreName !== ''">
        <p>This area displays the form version of the config for a mulesoft core.</p>
        <json-form ref="form" :label-width="80" v-model="myData"></json-form>
        <br />
        <Button type="primary" @click="updateCore">Submit Config Update</Button>

        <br />
        <br />
        <br />
        <br />
        <Input
          v-model="jsonString"
          type="textarea"
          :autosize="true"
          placeholder="Paste correctly formatted JSON here"
        ></Input>
        <br />
        <br />
        <Button type="primary" @click="jsonToForm">Convert JSON to Form</Button>
        <br />
        <br />
        <br />
      </div>
    </div>
    <Modal v-model="errorModal" title="Error">
      <p>{{error}}</p>
    </Modal>
  </div>
</template>

<script>
import JsonForm from '@/components/JsonForm.vue';
import MulesoftTable from '@/components/MulesoftCoreTable.vue';
import axios from 'axios';
import MulesoftCoreService from '@/MulesoftCoreService';

export default {
  name: 'MulesoftCore',
  components: {
    JsonForm,
    MulesoftTable,
  },
  data() {
    return {
      jsonString: '',
      myData: {},
      errorModal: false,
      error: '',
      version: 'v1',
      coreName: '',
      configData: {},
    };
  },

  mounted() {},
  methods: {
    updateCore() {
      this.myData.version = this.version;
      this.myData.coreName = this.coreName;
      /* eslint-disable consistent-return */
      this.jsonString = JSON.stringify(
        this.myData,
        (key, value) => {
          if (value !== null) return value;
        },
        4,
      );
      /* eslint-enable consistent-return */
      MulesoftCoreService.updateMulesoftCore(JSON.parse(this.jsonString));
      this.loading = false;
    },
    async setCoreConfig(currentCore) {
      this.coreName = currentCore.coreName;
      this.myData = await MulesoftCoreService.getMulesoftConfig(this.version, this.coreName);
      this.loading = false;
    },
    jsonToForm() {
      try {
        this.myData = JSON.parse(this.jsonString);
      } catch (e) {
        this.error = 'Invalid JSON!';
        this.errorModal = true;
      }
      this.jsonString = '';
    },
    formToJSON() {
      /* eslint-disable consistent-return */
      try {
        this.jsonString = JSON.stringify(
          this.myData,
          (key, value) => {
            if (value !== null) return value;
          },
          4,
        );
        /* eslint-enable consistent-return */
      } catch (e) {
        this.error = 'Connot convert to JSON!';
        console.log(e);
        this.errorModal = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

.vue-json-form {
  display: block;
  margin: 0 auto;
  width: 60%;
}
</style>
